import Register from 'features/POSRegisters/interfaces/Register';

export const getDeviceList = ({
  ipad,
  ipadMini,
  receiptPrinter,
  cashDrawer,
  barcodeScanner,
  paymentTerminal,
}: Register) => [ipad, ipadMini, receiptPrinter, cashDrawer, barcodeScanner, paymentTerminal];
